<section class="why-althea">

    <div class="container-redesign">

        <div class="why-althea__grid">

            <div class="why-althea__left">

                <h2 class="why-althea__title">

                    {{ title }}

                </h2>

                <p class="why-althea__subtitle">

                    {{ subtitle }}

                </p>

                <div class="why-althea__timeline">

                    <article
                        *ngFor="let item of items; trackBy: trackByTitle"
                        class="why-althea__item">

                        <div class="why-althea__icon-wrapper">

                            <img
                                [src]="item.icon"
                                [alt]="item.title"
                                class="why-althea__icon">

                        </div>

                        <div class="why-althea__item-content">

                            <h3 class="why-althea__item-title">

                                {{ item.title }}

                            </h3>

                            <p class="why-althea__item-description">

                                {{ item.description }}

                            </p>

                        </div>

                    </article>

                </div>

            </div>

            <div class="why-althea__right">

                <p class="why-althea__description">

                    {{ description }}

                </p>

                <img
                    [src]="image"
                    [alt]="imageAlt"
                    class="why-althea__image">

            </div>

        </div>

        <p class="why-althea__footer">

            {{ footer }}

        </p>

    </div>

</section>